import useAxios from 'hooks/useAxios';

export async function createItem(name, gems, coins, type, rarity, image, unrealItemId, tags, metadata, itemId, isActive) {
  const api = useAxios();
  const formData = new FormData();
  formData.append('name', name);
  formData.append('priceGems', gems);
  formData.append('priceCoins', coins);
  formData.append('type', type);
  formData.append('rarity', rarity);
  formData.append('file', image);
  formData.append('unrealItemId', unrealItemId);
  
  // Optional fields
  if (tags) {
    formData.append('tags', tags);
  }
  if (metadata) {
    formData.append('metadata', metadata);
  }
  if (itemId) {
    formData.append('itemId', itemId);
  }
  if (typeof isActive === 'boolean') {
    formData.append('isActive', isActive);
  }

  try {
    const res = await api.post('/items', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res;
  } catch (err) {
    return err;
  }
}
